// removed by extract-text-webpack-plugin
module.exports = {"container":"_2FakczP_Qvh2gqAL7DXmSn","logo":"_2cP2ave9S8LF40Lx1usXVo","title":"_2fdiY7fMxZDe9AseBOwL3D","link":"_2C3dvc706DVEVFZLjNvVPY","cmcLogo":"_2pZoMbnTPTkckAOA3pFjmL"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/Footer/styles.css
// module id = 1650
// module chunks = 85